module.exports = __webpack_public_path__ + "static/media/designPatent_30-1050484.af11ab87.png";